<template>
  <div>
    <Modal v-model="visible" title="新增" width="460" class="my-modal top" :mask-closable="false" :footer-hide="true">
      <Form v-if="showPupUp" ref="form" :model="formData" class="full form" :label-width="90">
        <FormItem prop="orgIds" label="机构名称" :rules="$units.formRule.required('请选择', 'change', 'array')" class="full">
          <selectTree ref="selectTreeRef" v-model="formData.orgIds" :multiple="true" type="4" :selectAll="false"></selectTree>
        </FormItem>

        <FormItem prop="startTime" :rules="$units.formRule.required('请选择开始时间', (trigger = 'change'), (type = 'date'))" label="开始时间" class="full">
          <DatePicker
            style="width: 100%"
            :editable="false"
            :clearable="true"
            type="date"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            v-model="formData.startTime"
            format="yyyy-MM-dd"
            placeholder="请选择"
            :options="options"
          >
          </DatePicker>
        </FormItem>

        <FormItem prop="endTime" :rules="$units.formRule.required('请选择结束时间', (trigger = 'change'), (type = 'date'))" label="结束时间" class="full">
          <DatePicker
            style="width: 100%"
            :editable="false"
            :clearable="true"
            type="date"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            v-model="formData.endTime"
            format="yyyy-MM-dd"
            placeholder="请选择"
            :options="options"
          >
          </DatePicker>
        </FormItem>
      </Form>

      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import filter from '@/api/filter';
import selectTree from '@/components/system/selectTree3';
export default {
  props: [],
  components: { selectTree },
  data() {
    return {
      filter,
      visible: false,
      showPupUp: false,
      formData: {
        startTime: '',
        endTime: '',
        baseId: '',
        orgIds: []
      },
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now();
        }
      }
    };
  },
  methods: {
    open(data = {}) {
      this.visible = true;
      this.showPupUp = true;
      this.formData = {};
      if (data.id) {
        this.formData.baseId = data.id;
      }
      this.$refs.form && this.$refs.form.resetFields();
    },

    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }

        let startTime = filter.filterTime(this.formData.startTime, 'YYYY-MM-DD');
        let endTime = filter.filterTime(this.formData.endTime, 'YYYY-MM-DD');

        if (startTime >= endTime) {
          this.$Message.error(`结束时间需要大于开始时间`);
          return;
        }

        let data = {
          ...this.formData,
          // orgIds:[this.formData.orgId],
          startTime,
          endTime
        };
        this.$http({
          url: '/buz/baseAssign/add',
          type: 'POST',
          data
        }).then(res => {
          this.formData = {};
          this.$notice.success('新增成功');
          this.$emit('reload')
          this.visible = false;
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  .form {
    margin-top: 10px;
  }

  /deep/ {
    .ivu-modal-body {
      padding-top: 0;
    }
  }
}
</style>
